import React from 'react'
import { DashboardLayout } from '../layouts'
import { AddAgentForm } from '../containers'

function AddAgent() {
  return (
    <DashboardLayout>
        <div>

            <AddAgentForm/>

        </div>

    </DashboardLayout>
  )
}

export default AddAgent